import React from "react";
import "../CSS/SubProduct.css";
import image1 from "../Assets/Living/Product-Main/THROWS 1.jpg";
import image2 from "../Assets/Living/Product-Main/THROWS 2.jpg";
import image3 from "../Assets/Living/Product-Main/THROWS 3.jpg";
import image4 from "../Assets/Living/Product-Main/THROWS 4.jpg";

function Throws() {
  return (
    <div className="product-main">
      <div>
        <div className="sub-product-head">
          <h3>Throws</h3>
        </div>
        <div className="sub-product-flex">
          <img src={image1} />
          <img src={image2} />
          <img src={image3} />
          <img src={image4} />
        </div>
      </div>
    </div>
  );
}
export default Throws;
